import gql from 'graphql-tag';

export const UPDATE_ABOUT_ME_MUTATION = gql`
    mutation updateUserAboutMe($input: UserAboutMeInput!) {
        updateUserAboutMe(input: $input)
    }
`;
